/**
 * Skeletons fade in rather than appearing instantly, so a response that beats
 * the delay swaps straight to content with no placeholder flash. The skeleton
 * still occupies its full space while invisible, so nothing reflows.
 */
export const REVEAL_DELAY = '120ms';
export const REVEAL_DURATION = '220ms';

/**
 * Line widths cycle through this ramp so a run of text lines reads as prose
 * instead of a stack of identical bars. Indexing (rather than randomising)
 * keeps a given line the same width on every render.
 */
export const LINE_WIDTHS = [97, 89, 94, 82, 91, 86] as const;

/** Final line of a paragraph, which in real text rarely fills the measure. */
export const LAST_LINE_WIDTH = 63;

/**
 * Fill and sheen for a skeleton sitting on a saturated surface — the brand
 * gradient hero, a subject-coloured band — where the default ink tint has no
 * contrast to work with.
 */
export const CONTRAST_FILL = 'rgba(255,255,255,0.2)';
export const CONTRAST_SHEEN = 'rgba(255,255,255,0.32)';

/** Heights of the interactive elements skeletons stand in for, in pixels. */
export const CHIP_HEIGHT = { small: 24, medium: 32 } as const;
export const BUTTON_HEIGHT = { small: 32, medium: 40, large: 44 } as const;
export const ICON_BUTTON_SIZE = 40;
/** A `size='small'` IconButton: 5px of padding around a 24px icon. */
export const SMALL_ICON_BUTTON_SIZE = 34;
/** A `size='small'` outlined field, which every select in the app is. */
export const SELECT_HEIGHT = 40;

/** `DataGrid` header and row heights, mirrored by `SkeletonTable`. */
export const TABLE_HEADER_HEIGHT = 56;
export const TABLE_ROW_HEIGHT = 40;

/** Width of the `CommitForm` field label gutter. */
export const FIELD_LABEL_WIDTH = 96;
